import React from "react"
import { isAuthenticatedPure } from "./components/user/redux/reducers"
import { Route } from "react-router-dom"
import { Arwes, Project } from "arwes"
import styled from "styled-components"
import {
  ContentColumn,
  PageBlock,
  PageOffset
} from "./common/styled/Page"

const AccessPanel = styled.div`
  padding-top: 126px;

  @media (max-width: 900px) {
    padding-top: 8px;
  }
`

const PrivateRoute = ({ component: Component, isExpanded, ...rest }) => {
  const isAuth =
    isAuthenticatedPure() &&
    isAuthenticatedPure().payload &&
    isAuthenticatedPure().payload.token
  return (
    <Route
      {...rest}
      render={props =>
        isAuth ? (
          <Component {...props} isExpanded={isExpanded} />
        ) : (
          <Arwes>
            <PageOffset isExpanded={isExpanded}>
              <ContentColumn>
                <PageBlock>
                  <AccessPanel>
                    <Project animate header={"Access Denied"}>
                      Sign in to continue.
                    </Project>
                  </AccessPanel>
                </PageBlock>
              </ContentColumn>
            </PageOffset>
          </Arwes>
        )
      }
    />
  )
}

export default PrivateRoute
